module.exports = __webpack_public_path__ + "static/media/file-chart-pie.af02b957.svg";